// extracted by mini-css-extract-plugin
export var container = "_ev-1";
export var cornerButtonContainer = "_ev-6";
export var disabled = "_ev-2";
export var dragActive = "_ev-3";
export var fileContainer = "_ev-5";
export var hiddenInput = "_ev-4";
export var widthContainer = "_ev-0";